import { render, staticRenderFns } from "./MultiObjBox.vue?vue&type=template&id=5863f2f2&scoped=true"
import script from "./MultiObjBox.vue?vue&type=script&lang=js"
export * from "./MultiObjBox.vue?vue&type=script&lang=js"
import style0 from "./MultiObjBox.vue?vue&type=style&index=0&id=5863f2f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5863f2f2",
  null
  
)

export default component.exports